import { useCallback, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { modal } from "./ModalService";

export default function ModalProvider({ children }) {
  const [state, setState] = useState(null); // {type, title, message, ... , _resolve}
  const lastActive = useRef(null);

  const close = useCallback((result) => {
    setState((current) => {
      if (!current) return current;
      current._resolve?.(result);
      return null;
    });
    setTimeout(() => lastActive.current?.focus?.(), 0);
  }, []);

  useEffect(() => {
    const unsub = modal._subscribe((type, payload) => {
      if (type === "open") {
        lastActive.current = document.activeElement;
        setState(payload);
      } else if (type === "close") {
        close(payload);
      }
    });
    return unsub;
  }, [close]);

  // ESC 닫기
  useEffect(() => {
    if (!state) return;
    const onKey = (e) => {
      if (e.key === "Escape") close(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [close, state]);

  const showActions = state?.type === "confirm" || state?.type === "alert";
  const cancelLabel =
    state?.type === "confirm"
      ? state.cancelText || "취소"
      : state?.cancelText || "닫기";

  return (
    <>
      {children}
      {state &&
        createPortal(
          <div
            className="ghm-ov"
            role="presentation"
            onClick={() => state.backdropClose !== false && close(false)}
          >
            <div
              role="dialog"
              aria-modal="true"
              className="ghm-card"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="ghm-body">
                {state.title && <h3 className="ghm-title">{state.title}</h3>}
                {state.message && <p className="ghm-msg">{state.message}</p>}
                {state.type === "custom" &&
                  typeof state.render === "function" &&
                  state.render(close)}
              </div>

              {showActions && (
                <div className="ghm-actions">
                  <button
                    className="ghm-btn ghm-btn--ghost"
                    onClick={() => close(false)}
                  >
                    {cancelLabel}
                  </button>
                  <button
                    className="ghm-btn ghm-btn--primary"
                    onClick={() => close(true)}
                  >
                    {state.okText || "확인"}
                  </button>
                </div>
              )}
            </div>
          </div>,
          document.body
        )}
    </>
  );
}
